let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lqpfq")).then(() => parcelRequire('iXgCK'));